import { HalfCircleSpinner } from 'epic-spinners';
import { dateFilter } from '@/utils/filters';
import { USER_TYPE } from '@/utils/constants';
import moment from 'moment';
export default {
    name: 'quotationData',
    props: { isMobile: Boolean, competition: Object, loader: Boolean, guest: Boolean },
    components: { HalfCircleSpinner },
    methods: {
        dateFilter,
        openLink(link) {
            window.open(link, '_blank');
        }
    },
    computed: {
        iconTitle() {
            const obj = {
                'Construção civil': 'hard-hat.svg',
                contractor_type: 'hard-hat.svg',
                'Cliente Engelink': 'house.svg',
                'Pessoa Física': 'house.svg',
                Corporativo: 'business.svg',
                Condomínio: 'building.svg',
                Solicitante: 'building.svg',
                Administradora: 'building.svg',
                'Síndico(a) profissional': 'building.svg'
            };
            return require('@/assets/images/' + obj[this.competition.contractorTypeValue]);
        },
        isDateInPast() {
            return moment(this.competition.endingDate) > new Date()
                ? dateFilter(this.competition.endingDate)
                : 'O mais rápido possível';
        },
        contractorType() {
            if (
                this.competition.contractorTypeKey === USER_TYPE.REQUESTER ||
                this.competition.contractorTypeKey === USER_TYPE.CONDO_ADMINISTRATOR ||
                this.competition.contractorTypeKey === USER_TYPE.PROFESSIONAL_BUILDING_MANAGER
            ) {
                return 'Condomínio';
            } else if (this.competition.contractorTypeKey === USER_TYPE.PRIVATE_PERSON) {
                return 'Cliente Engelink';
            } else {
                return this.competition.contractorTypeValue;
            }
        },
        publicOrganizationLink() {
            const array = [];
            if (this.competition.publicOrganizationLink.length && this.competition.hasOccupation)
                array.push(this.competition.publicOrganizationLink);
            return array;
        },
        links() {
            const array = this.competition.links.links;
            return array;
        }
    }
};
